import * as React from 'react';
import './old-tx-ids.scss';
import { Page } from 'components/page/page';
import { Card } from 'components/card/card';
import { Table } from 'components/table/table';
import { Badge } from 'components';
import { CopyOutlined, DeleteOutlined, ExportOutlined, PlusCircleFilled } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Button, buttonType } from 'components/button/button';
import { Input } from 'components/input/input';
// import { ClientSidePagination } from "components/pagination/pagination";
import { PaginationList } from '../../../../core/domain/commons/common';
import { getPageNum } from 'core/utils/paggingHelper';
import { copyToClipboard } from 'core/utils/copyToClipboard';
import { formatCardNumber } from 'core/utils/bankDetecter';
import { Modal } from 'components/modal/modal';
import { downloadCSV } from '../../../../core/utils/export-to-file';
import { getAllOldTxIds } from 'core/repositories/old-tx-ids';
import { OldTxId } from 'core/domain/old-tx-ids/old-tx-ids';

interface FilterValues {
    search: string;
}

const empty_filters = {
    search: '',
};

export const OldTxIds: React.FC = () => {
    const [oldTxIds, setOldTxIds] = React.useState<PaginationList<OldTxId>>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = React.useState<boolean>(false);
    const [deleteModalButtonLoading, setDeleteModalButtonLoading] = React.useState<boolean>(false);
    const [deleteButtonLoading, setDeleteButtonLoading] = React.useState<boolean>(false);
    const [filterValues, setFilterValues] = React.useState<FilterValues>(empty_filters);
    const [query, setQuery] = React.useState<string>('');
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [selectedItem, setSelectedItem] = React.useState<OldTxId>();
    const [pageSize, setPageSize] = React.useState<number>(10);

    const navigate = useNavigate();

    const clearFiltersHandle = () => {
        setFilterValues(empty_filters);
        filterHandle(true);
    };

    const filterHandle = (clearFilter?: boolean) => {
        var _query = '';

        if (filterValues.search) _query += `${_query.includes('?') ? '&' : '?'}keywords=${filterValues.search}`;

        setQuery(_query);
        getAllOldTxIds(
            clearFilter ? setDeleteButtonLoading : _query !== '' ? setButtonLoading : setLoading,
            setOldTxIds,
            1,
            pageSize,
            clearFilter ? '' : _query,
        );
    };

    React.useEffect(() => {
        getAllOldTxIds(setLoading, setOldTxIds, getPageNum(), pageSize);
    }, []);

    const columns: any[] = [
        {
            name: 'نماد',
            id: 'coin',
            selector: (row: OldTxId) => row.coin,
            width: '15%',
        },
        {
            name: 'هش',
            id: 'fullName',
            selector: (row: OldTxId) => row.txId,
            width: '85%',
        },
    ];

    return (
        <Page className="pmx-old-tx-ids" title="هش های سوخته شده">
            <Card title="لیست هش های سوخته شده" blur={loading}>
                <Button
                    type={buttonType.info}
                    text="سوزاندن هش"
                    icon={<PlusCircleFilled />}
                    onClick={() => navigate('create')}
                />
                <div className="filter-row">
                    {/* <div className="fields">
                        <Input
                            value={filterValues.search}
                            className="search"
                            placeholder="جستجو کنید ..."
                            name="search"
                            onPressEnter={filterHandle}
                            onChange={(e) => setFilterValues({ ...filterValues, search: e.target.value })}
                        />
                    </div> */}
                    <div className="buttons">
                        <Button
                            loading={buttonLoading}
                            disabled={buttonLoading}
                            text="اعمال فیلتر"
                            type={buttonType.success}
                            onClick={() => filterHandle()}
                        />
                        <Button
                            text="خروجی اکسل"
                            type={buttonType.info}
                            icon={<ExportOutlined />}
                            onClick={(event) => downloadCSV('هش های سوخته', oldTxIds.items)}
                        />
                    </div>
                </div>
                {oldTxIds?.items && oldTxIds?.items.length > 0 && (
                    <>
                        <Table
                            setPageSize={setPageSize}
                            blur={loading}
                            setloader={setLoading}
                            getdata={getAllOldTxIds}
                            setdata={setOldTxIds}
                            pagination={oldTxIds.pagination}
                            className="old-tx-ids-table"
                            data={oldTxIds.items}
                            column={columns}
                            filters={query}
                        />
                    </>
                )}
            </Card>
        </Page>
    );
};
